import { Stack } from "@mui/material";
import { useState } from "react";
import Iconify from "../iconify/iconify";

import { TextEdit } from "./TextEdit";

import { usePropertiesSlug } from "../../hooks/use-data-properties";
import { patch } from "../utils/request";
import { useSearchParams } from "react-router-dom";
import { useAuthStore } from "../../stores/authStore";

export const PropertyLocalEdit = ({ slug }) => {
  const { dataPropertiesSlugQuery } = usePropertiesSlug(slug);

  const [isEditing, setIsEditing] = useState(false);
  const [descripcionTitle, setDescripcionTitle] = useState(
    dataPropertiesSlugQuery?.data?.city || "Tlaquepaque, Jalisco. MX"
  );
  const { auth } = useAuthStore();

  const handleSave = async () => {
    try {
      const data = {
        descripcionTitle,
      };

      await patch({
        path: `/properties/local/${slug}`,
        data,
        token: auth.accessToken,
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.log(error);
    }

    setIsEditing(false);
  };
  return (
    <Stack direction="row" gap={1} position="relative">
      <TextEdit
        variant="subtitle1"
        color="text.secondary"
        content={descripcionTitle}
        onSaveChange={(content) => {
          setDescripcionTitle(content);
          setIsEditing(true);
        }}
      />
      {isEditing && (
        <Stack direction="row-reverse" alignItems="center" gap={1}>
          <Iconify
            icon="mdi:content-save"
            sx={{
              cursor: "pointer",
              color: "text.secondary",
              fontSize: 400,
              "&:hover": {
                color: "text.primary", // Cambia color al hover
              },
            }}
            onClick={handleSave}
          />
          {/* <Iconify icon="mdi:content-save" sx={{ color: "text.secondary" }} /> */}
        </Stack>
      )}
    </Stack>
  );
};
